import type { ICondition } from '@/Interfaces/CampaignManagement/LineItemStatusTooltip.interface';
import LineItemStatusTooltipContent from '@/pages/CampaignManagement/components/LineItemStatusTooltip';
import { Button, type ButtonProps, Tooltip, styled } from '@mui/material';
import { memo } from 'react';

const StyledButton = styled(Button)({
  height: '32px',
  borderRadius: '50px',
  border: '1px solid #C4D0CB',
  padding: '6px 12px',
});

interface IProps {
  isActive: boolean;
  conditions: ICondition[];
  onToggle: () => void;
  disabled?: boolean;
}

const LineItemActivationButton = memo(({ isActive, conditions, onToggle, disabled }: IProps) => {
  const buttonProps: ButtonProps = {
    variant: 'outlined',
    color: 'primary',
    onClick: onToggle,
  };

  const label = isActive ? 'Deactivate' : 'Activate';

  if (conditions?.length && conditions.some(cnd => !cnd.checked)) {
    return (
      <Tooltip title={<LineItemStatusTooltipContent conditions={conditions} />}>
        <span>
          <StyledButton {...buttonProps} disabled>
            {label}
          </StyledButton>
        </span>
      </Tooltip>
    );
  }

  return (
    <StyledButton {...buttonProps} disabled={disabled}>
      {label}
    </StyledButton>
  );
});

export default LineItemActivationButton;
